import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import '../styles/dashboard.css';
import '../styles/congratulations.css';
import logo from '../assets/logo.png';
import award from '../assets/award.png';
import ProfileDropdown from '../components/ProfileDropdown';
import PortalFaqHelp from '../components/PortalFaqHelp';


export default function CongratulationsPage() {
  const user   = JSON.parse(localStorage.getItem('user'))   || {};
  const result = JSON.parse(sessionStorage.getItem('result') || localStorage.getItem('result') || '{}') || {};
  const examTitle = result.examTitle || localStorage.getItem('activeExamTitle') || 'your assessment';

  const userName = user.name || 'Candidate';

  // Confetti animation on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      confetti({
        particleCount: 200,
        angle: 90,
        spread: 120,
        origin: { x: 0.5, y: 0 },
        gravity: 1.2,
        ticks: 300,
        colors: ['#4F8EF7', '#A9C5F3', '#FF6B6B', '#FFD93D', '#6BCB77', '#ffffff'],
      });
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const formatTime = (seconds) => {
    if (seconds === undefined || seconds === null) return 'N/A';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const submittedDate = result.submittedAt ? new Date(result.submittedAt) : new Date();
  const submittedOn = submittedDate.toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });

  const questionsAttempted = `${result.answeredCount ?? 0} of ${result.totalQuestions ?? 0}`;

  return (
    <div className="congrats-page">

      <nav className="dash-nav">
        <img src={logo} alt="Inteliment Logo" className="dash-logo" />
        <div className="dash-nav-right">
          <PortalFaqHelp />
          <ProfileDropdown user={userName} email={user.email} />
        </div>
      </nav>

      <div className="congrats-bg">
        <div className="congrats-card">

          <div className="congrats-left">
            <div className="congrats-medal-scene">
              <svg className="circles-svg" width="461" height="455" viewBox="0 0 461 455" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="157.622" cy="255.692" r="302.802" fill="#DAE6FA" fillOpacity="0.3"/>
                <circle cx="158.244" cy="256.314" r="247.465" fill="#CBDCF8" fillOpacity="0.4"/>
                <circle cx="157.623" cy="255.691" r="183.422" fill="#BCD2F6" fillOpacity="0.3"/>
                <circle cx="158.244" cy="256.313" r="119.38"  fill="#A9C5F3" fillOpacity="0.4"/>
              </svg>
              <img src={award} alt="Award" className="award-img" />
            </div>
          </div>

          <div className="congrats-right">
            <div className="congrats-tag">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#4BAD92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              <span>EXAM COMPLETED SUCCESSFULLY</span>
            </div>

            <h1 className="congrats-heading">Congratulations, {userName.split(' ')[0]}!</h1>
            <p className="congrats-body">
              Your {examTitle} has been successfully submitted, and you have been shortlisted for the next round of the recruitment process.
            </p>
            <p className="congrats-body" style={{ marginTop: -20 }}>
              Our Recruitment Team will connect with you soon regarding the upcoming stages.
            </p>
            <p className="congrats-body" style={{ marginTop: -20 }}>
              We appreciate your participation and wish you continued success.
            </p>

            <div className="congrats-stats">

              {/* TIME TAKEN */}
              <div className="congrats-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_1018_5568)">
                    <path d="M8.12988 14.9014C11.8707 14.9014 14.9033 11.8688 14.9033 8.12793C14.9033 4.38706 11.8707 1.35449 8.12988 1.35449C4.38902 1.35449 1.35645 4.38706 1.35645 8.12793C1.35645 11.8688 4.38902 14.9014 8.12988 14.9014Z" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.12988 4.06396V8.12803L10.8393 9.48271" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1018_5568">
                      <rect width="16.2563" height="16.2563" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span className="congrats-stat-label">TIME TAKEN</span>
                <span className="congrats-stat-value">{formatTime(result.timeTaken)}</span>
              </div>

              <div className="congrats-stat-divider" />

              {/* QUESTIONS ATTEMPTED */}
              <div className="congrats-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.03271 2.03174V12.8692C2.03271 13.2285 2.17544 13.5731 2.42949 13.8271C2.68355 14.0812 3.02812 14.2239 3.3874 14.2239H14.2249" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.1929 11.5147V6.09595" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.80615 11.5146V3.38647" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.41943 11.5147V9.48267" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="congrats-stat-label">QUESTIONS ATTEMPTED</span>
                <span className="congrats-stat-value">{questionsAttempted}</span>
              </div>

              <div className="congrats-stat-divider" />

              {/* SUBMITTED ON */}
              <div className="congrats-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.41846 1.35449V4.06387" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10.8374 1.35449V4.06387" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.8692 2.70923H3.38643C2.63825 2.70923 2.03174 3.31574 2.03174 4.06392V13.5467C2.03174 14.2949 2.63825 14.9014 3.38643 14.9014H12.8692C13.6174 14.9014 14.2239 14.2949 14.2239 13.5467V4.06392C14.2239 3.31574 13.6174 2.70923 12.8692 2.70923Z" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.03174 6.77319H14.2239" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="congrats-stat-label">SUBMITTED ON</span>
                <span className="congrats-stat-value">{submittedOn}</span>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
